import {
  setVisibility,
  setVisibilityFalse,
  updatedRiskProfile,
} from '../components/investors/riskProfileDetails';

export default function updateVisibility(
  answer: string | string[],
  q: Partial<updatedRiskProfile>,
  formValues: updatedRiskProfile[]
): void {
  if (q.questionType === 'multipleSelect' || q.questionType === 'multiSelectCheckBox') {
    const incudedAns = q.values
      ?.filter((e) => {
        return answer.includes(e.key);
      })
      .map((e) => e.showQs)
      .flat();

    const excludedAns = q.values
      ?.filter((e) => {
        return !answer.includes(e.key);
      })
      .map((e) => {
        if (e.hideQs && e.hideQs.length > 0) {
          return [...e.hideQs, ...(e.showQs || [])]?.sort();
        } else {
          return e.showQs;
        }
      })
      .flat();

    incudedAns?.forEach((qns) => {
      formValues.forEach((ques) => {
        setVisibility(qns as string, ques, formValues);
      });
    });
    excludedAns?.forEach((qns) => {
      formValues.forEach((ques) => {
        setVisibilityFalse(qns as string, ques, formValues);
      });
    });
  }

  if (q.questionType === 'radio') {
    const filteredOption = q.values?.filter((option) => option.key === answer);

    const showQs =
      filteredOption && filteredOption?.length > 0 ? filteredOption[0].showQs || [] : [];
    const hideQs =
      filteredOption && filteredOption?.length > 0 ? filteredOption[0].hideQs || [] : [];
    showQs?.forEach((qns) => {
      formValues.forEach((ques) => {
        setVisibility(qns, ques, formValues);
      });
    });
    hideQs?.forEach((qns: any) => {
      formValues.forEach((ques) => {
        setVisibilityFalse(qns, ques, formValues);
      });
    });
  }
}

export const groupTypeCheck = (groupRadioQns: string): boolean => {
  return groupRadioQns === 'groupText';
};
